<script lang="ts" setup>
interface Props {
  itemHistory: LocationItemHistoryDTO;
}
const props = defineProps<Props>();
const { d, t, n } = useEkI18n();

const title = computed(() => {
  if (props.itemHistory.Delta >= 0) {
    return t('dateLabels.to') + ' ' + props.itemHistory.LocationName;
  } else {
    return t('dateLabels.from') + ' ' + props.itemHistory.LocationName;
  }
});
const deltaWithColor = computed(() => {
  const deltaValue = props.itemHistory.Delta;
  const colorClass = deltaValue >= 0 ? 'positive-delta' : 'negative-delta';

  return { value: deltaValue, colorClass };
});
</script>

<template>
  <IonItem
    lines="full"
    color="card-background"
  >
    <IonGrid class="ion-no-padding grid-container">
      <div class="title">
        <span>{{ title }}</span>
      </div>
      <IonRow class="ion-justify-content-between medium-padding-top">
        <IonCol
          class="ion-no-padding details"
          size="auto"
        >
          <IonRow class="ion-activatable ripple-parent rounded-rectangle detail">
            <span>{{ itemHistory.UpdatedDate ? d(itemHistory.UpdatedDate, 'dateFormats.writtenDayMonthYearTime') : ( itemHistory.CreatedDate ? d(itemHistory.CreatedDate, 'dateFormats.writtenDayMonthYearTime') : t('labels.notAvailable')) }}</span>
          </IonRow>
          <IonRow class="ion-activatable ripple-parent rounded-rectangle detail">
            <span>{{ itemHistory.UpdatedByUserName ? itemHistory.UpdatedByUserName : itemHistory.CreatedByUserName }}</span>
          </IonRow>
        </IonCol>
        <IonCol
          size="auto"
          class="ion-no-padding price"
        >
          <IonRow>
            <span class="unit">{{ itemHistory.UnitShortName.toLowerCase() }}</span>
          </IonRow>
          <IonRow>
            <span :class="deltaWithColor.colorClass"><strong>{{ n(deltaWithColor.value, 'currency') }}</strong></span>
          </IonRow>
        </IonCol>
      </IonRow>
    </IonGrid>
  </IonItem>
</template>

<style scoped>
.details {
  display: flex;
  font-size: smaller;
  flex-direction: column;
}

.detail {
  display: flex;
  justify-items: start;
  align-items: center;
  gap: 6px;
  padding: 4px 0px;
  position: relative;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  display: flex;
  justify-content: end;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 4px;
  align-items: end;
  justify-items: end;

  .unit {
    font-size: small;
  }
}

.medium-padding-top {
  padding-top: 8px;
}

.grid-container {
  padding: 16px 0px 12px 0px;
}
.positive-delta {
  color: green;
}

.negative-delta {
  color: red;
}
</style>
